export default __webpack_public_path__ + "static/media/background-3.7b65bf1d.png";